const ConstantKey = {
    //REACT_GA_TRACKING_ID: 'UA-195320645-1', //para pruebas
    REACT_GA_TRACKING_ID: 'UA-195320645-1', //productiva
};

export default ConstantKey